import { render, staticRenderFns } from "./security_recommendations_page.vue?vue&type=template&id=0a0866da"
import script from "./security_recommendations_page.vue?vue&type=script&lang=js"
export * from "./security_recommendations_page.vue?vue&type=script&lang=js"
import style0 from "./security_recommendations_page.vue?vue&type=style&index=0&id=0a0866da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports